import { SetWinningsCommand } from "slotworks/commands/betbar/set-winnings-command";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import Bet from "slotworks/model/bets/bet-model";
import Gamestate from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SmartButton from "slotworks/smart-button/smart-button";
import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";
import Contract from "slotworks/utils/contract";
import { sequence } from "slotworks/utils/race-utils";

export default class RevolverExitFreespins extends ExitFreespins {

    protected setupPrompt(): Contract<void> {
        const freespinsRecord = Gamestate.getCurrentGame().getCurrentRecord() as FreespinRecord;
        const freespinsPlayed = freespinsRecord.totalFreespins.toString();

        this.promptContents.set("fs_played", Translations.get("fs.fsp", { played: freespinsPlayed, spins: freespinsPlayed, SPINS: freespinsPlayed }));

        return super.setupPrompt();
    }

    protected celebrateWin(freeSpinsWin: number): Contract<void> {
        return this.checkAdditionalWin(freeSpinsWin);
    }

    protected afterPrompt() {
        const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();

        return sequence([
            () => super.afterPrompt(),
            () => this.celebrateWin(freeSpinsWin)
        ]);
    }

    protected resetToTriggeringSpin() {
        return Contract.wrap(() => {
            const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();

            SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);

            Components.betBar.setType(BetBarType.DEFAULT);
            Components.betBar.setEnabled(false);

            const betMenuMediator = new BetMenuMediator();
            betMenuMediator.start().execute();
            betMenuMediator.end();

            const record = Gamestate.getCurrentGame().resetRecordIndex() as SpinRecord;

            const triggeringWin: number = record.creditsWon;

            record.creditsWon += freeSpinsWin;
            record.beenPaid = true;

            this.showTriggeringSpinWin(record.creditsWon, triggeringWin);

            Components.matrix.clearStuckSymbols();

            // Can't reset reels during recovered game
            if (!Gamestate.getCurrentGame().isRecovered) {
                if (record.stops) {
                    Components.matrix.jump(record.stops, record.reelset);
                } else {
                    Components.matrix.jumpToGrid(record.grid);
                }
            }
        });
    }

    protected showTriggeringSpinWin(totalWin: number, triggeringWin: number) {
        const isBigWin = Components.bigWin.isBigWin(totalWin, Bet.getTotalBet());

        if (!isBigWin) {
            Components.betBar.winnings.setWinnings(triggeringWin);
        }
    }

    protected checkAdditionalWin(creditsWon: number): Contract<void> {
        const totalWin = Gamestate.getCurrentGame().totalCreditsWon;
        const isBigWin = Components.bigWin.isBigWin(totalWin, Bet.getTotalBet());

        if (!isBigWin) {
            return Components.celebrateWin.additionalWin(creditsWon);
        }

        return Contract.empty();
    }

    protected setWinnings(): void {
        const totalWin = Gamestate.getCurrentGame().totalCreditsWon;
        const isBigWin = Components.bigWin.isBigWin(totalWin, Bet.getTotalBet());

        if (!isBigWin) {
            Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
        } else {
            Components.betBar.winnings.setWinnings(0);
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/revolver-exit-freespins.ts